import { forwardRef } from 'react';

import { Share } from '@phosphor-icons/react/dist/ssr';
import classnames from 'classnames';

import { DropdownMenu, UnstyledDropdownMenuContent, UnstyledDropdownMenuTrigger } from '@/ui/DropdownMenu';
import { PlatformShareButton } from '@/ui/PlatformShareButton';
import { useIsClient } from '@/utils/useIsClient';

import * as styles from '../PostActions.css';
import { CopyLinkButton } from './CopyLinkButton';

interface Props {
  title: string;
  description: string;
  url: string;
  translations?: Record<string, string>;
}

const PLATFORMS = ['email', 'x', 'linkedIn', 'meta', 'reddit', 'whatsApp'];

export const ShareDropdown = forwardRef<HTMLButtonElement, Props>(
  ({ title, description, url, translations, ...props }, ref) => {
    const isClient = useIsClient();
    const label = translations?.['search.pagination.share'];

    if (!isClient) {
      return (
        <button type="button" className={classnames('flex justify-center', styles.button)} aria-label={label}>
          <Share size="20" />
        </button>
      );
    }

    return (
      <DropdownMenu>
        <UnstyledDropdownMenuTrigger
          ref={ref}
          className={classnames('flex justify-center', styles.button)}
          {...props}
          aria-label={label}
        >
          <Share size="20" />
        </UnstyledDropdownMenuTrigger>
        <UnstyledDropdownMenuContent
          style={{
            minWidth: 'initial',
          }}
          side="top"
          className="grid grid-cols-2 gap-0 overflow-hidden shadow-md rounded-md"
        >
          <CopyLinkButton url={url} translations={translations} />
          {PLATFORMS.map((platform) => (
            <PlatformShareButton
              key={platform}
              className={classnames(styles.socialShareButton)}
              title={title}
              url={url}
              platform={platform}
            />
          ))}
        </UnstyledDropdownMenuContent>
      </DropdownMenu>
    );
  },
);
